function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.2302 0.269783C11.8491 -0.11128 11.2055 -0.0855634 10.7927 0.327285L6.24999 4.86995L1.70734 0.327297C1.29449 -0.085552 0.650854 -0.111268 0.269791 0.269795C-0.111273 0.650858 -0.0855563 1.2945 0.327293 1.70735L4.86995 6.25L0.327286 10.7927C-0.0855636 11.2055 -0.11128 11.8491 0.269784 12.2302C0.650847 12.6113 1.29449 12.5856 1.70733 12.1727L6.24999 7.63005L10.7927 12.1727C11.2055 12.5856 11.8492 12.6113 12.2302 12.2302C12.6113 11.8492 12.5856 11.2055 12.1727 10.7927L7.63004 6.25L12.1727 1.70733C12.5856 1.29449 12.6113 0.650847 12.2302 0.269783Z",
  fill: "#1C1C1C"
});

function SvgIcClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClose);
export default __webpack_public_path__ + "static/media/ic_close.98092002c5cce97339d79a001f6ae271.svg";
export { ForwardRef as ReactComponent };